/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-case-declarations */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable block-scoped-var */
import $ from 'jquery';
import { validateForm as validateSteppedForm } from '../../sections/donation-header/s-donation-form-multi-step';
import { validateForm as validateSingleForm } from '../../components/donation-form-single/c-donation-form-single';
import { validateForm as validateStandardForm } from '../../sections/donation-form-layout-multi-step/s-donation-form';
import { validateForm as validateDonationForm } from '../../components/donation-form/c-donation-form';
import { validateForm as validateStcDonationForm } from '../../components/stc-donation-form/c-stc-donation-form';
import paymentProcessingScene from '../../js/utils/payment-processing-scene';

window.paymentHost = document.getElementById('hidFzSandbox') ? 'https://paynow.pmnts-sandbox.io' : 'https://paynow.pmnts.io';

async function getFZUrl() {
    let url = '';
    const mode = getBackgroundType();
    try {
        const response = await fetch(`/api/fatzebra/getpaymenturl?mode=${mode}&hideButton=true`, { method: 'GET' });
        if (response.ok) {
            url = await response.text();
        } else {
            console.log('Error retrieving URL');
        }
        return url;
    } catch (e) {
        console.log(e);
    }
}

function getBackgroundType() {
    const formElem = document.querySelectorAll('section.s-donation-header, section.s-donation-form-single, section.s-donation-form-multi-step, donation-form-single, section.s-donation-form.payment-details.stc-form')[0];
    let typeOfForm = 'light';
    if (formElem) {
        if (formElem.classList.contains('donation-form-single')) {
            typeOfForm = 'light';
        } else if (formElem.classList.contains('s-donation-form-multi-step') || formElem.classList.contains('s-donation-form')) {
            typeOfForm = 'white';
        } else if (formElem.classList.contains('s-donation-header')) {
            typeOfForm = 'dark';
        }
    }

    return typeOfForm;
}


export function buildFZiFrame(url) {
    const fzIframe = document.createElement('iframe');
    fzIframe.setAttribute('src', url);
    fzIframe.setAttribute('allow', 'payment');
    fzIframe.setAttribute('height', 400);
    fzIframe.setAttribute('width', 600);
    fzIframe.setAttribute('id', 'fz-payment-iframe');

    return fzIframe;
}

function appendIframe(iFrame) {
    const iFrameLocation = document.getElementById('fat-zebra-payment-wrapper');
    iFrameLocation.appendChild(iFrame);
}

getFZUrl().then(url => {
    if (url.length > 0) {
        const iframe = buildFZiFrame(url);
        appendIframe(iframe);
        resizeIframeOnWindowResize(iframe);
    }
});


const button = document.getElementsByClassName('payment-submit-btn')[0];
const hidPaymentType = document.getElementById('hidPaymentType');
const $button = $('.js-form-validate.with-recaptcha') || $('.js-form-validate');
const form = document.querySelectorAll('section.s-donation-form-single, section.s-donation-form-multi-step, donation-form-single, section.s-donation-form.payment-details.stc-form, section .c-donation-form, section .c-stc-donation-form')[0];

if (button && button.classList.contains('payment-submit-btn')) {
    button.addEventListener('click', triggerCheckout);
}

function triggerCheckout(event) {
    if (hidPaymentType.value !== 'cc-form') {
        return;
    }
    const generatedIFrame = document.getElementById('fz-payment-iframe');
    event.preventDefault();
    const formIsValid = validatePaymentStep(form);

    if (generatedIFrame) {
        if (formIsValid) {
            if (hidPaymentType.value === 'cc-form') {
                generatedIFrame.contentWindow.postMessage('doCheckout', '*');
            } else {
                console.log('Checkout was not triggered, ', hidPaymentType.value);
            }
        } else {
            console.log('Form is invalid');
        }
    } else {
        console.error('no iframe found');
    }
}

function validatePaymentStep(form) {
    let formIsValid = false;
    if (form.classList.contains('donation-form-single')) {
        formIsValid = validateSingleForm();
    } else if (form.classList.contains('c-donation-form')) {
        formIsValid = validateDonationForm();
    } else if (form.classList.contains('c-stc-donation-form')) {
        formIsValid = validateStcDonationForm();
    } else if (form.classList.contains('s-donation-form-multi-step')) {
        formIsValid = validateSteppedForm(2);
    } else if (form.classList.contains('s-donation-form')) {
        formIsValid = validateStandardForm(2);
    }

    return formIsValid;
}

async function verifyFzResponse(formData) {
    const url = '/api/fatzebra/verifyresponse';
    const verifyData = {
        ResponseCode: formData.r,
        Token: formData.token,
        Verification: formData.v
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(verifyData)
        });
        if (!response.ok) {
            throw new Error('Failed to verify payment response');
        } else {
            return response.ok;
        }
    } catch (e) {
        console.error('Error with request: ', e);
        return false;
    }
}

const updateHiddenFields = formData => {
    const cardType = document.getElementById('hidCardType');
    const cardHolder = document.getElementById('hidCardHolder');
    const cardNum = document.getElementById('hidCardNumber');
    const cardExp = document.getElementById('hidCardExpiry');
    const cardToken = document.getElementById('hidCardToken');

    if (cardType && cardHolder && cardExp && cardToken && cardNum) {
        cardType.value = formData.card_type;
        cardHolder.value = formData.card_holder;
        cardNum.value = formData.card_number;
        cardExp.value = formData.card_expiry;
        cardToken.value = formData.token;
    }
};

function resizeIframeOnWindowResize(iframe) {
    // Function to update iframe dimensions based on window size
    let iframeElement = iframe;
    if (!iframe) {
        iframeElement = document.getElementById('fz-payment-iframe');
    }

    // Attach the update function to the window resize event
    window.addEventListener('resize', () => updateIframeSize);

    // Call the update function initially to set the size on page load
    updateIframeSize(iframeElement);
}

function updateIframeSize(iframeElement) {
    // Set the iframe width to 100% to fill the container horizontally
    iframeElement.style.width = '100%';
}

function handlePaymentSubmission(result) {
    if (result) {
        if (!button.classList.contains('js-click-to-submit')) {
            button.classList.add('js-click-to-submit');
        }
        if (button.classList.contains('with-recaptcha')) {
            const $hiddenToken = $button.siblings('.g-recaptcha-response');
            // we trigger the google recaptcha call for anti-bot measure
            // Only trigger the re-captcha if we havent got the google check token
            if ($hiddenToken.length && $hiddenToken.val()) {
                window.submitRecaptchaForm($hiddenToken.val());
            } else {
                window.grecaptcha.execute();
            }
        } else {
            triggerButtonPostback(button);
        }
    } else {
        throw new Error('Payment submission was not verified');
        // TODO: Handle non-verified results
    }
}

function triggerButtonPostback(button) {
    if (button.classList.contains('js-click-to-submit')) {
        if (!button.disabled) {
            button.disabled = true;
            button.classList.remove('js-click-to-submit');
            paymentProcessingScene();
            window.__doPostBack(button.name, 'Click');
        }
    }
}

function stringToList(str) {
    // Split the string into an array of substrings using commas as separators
    const words = str.split(',');
    return Array.from(new Set(words));
}

const messageListener = async function (event) {
    if (event.origin !== window.paymentHost) {
        return;
    }
    // Older browsers will have a query-string style data payload
    // Whereas newer browsers will have an object
    let payload = event.data;

    if (typeof event.data === 'string') {
        if (/\[object/i.test(event.data)) {
            alert('Sorry, it looks like there has been a problem communicating with your browser...'); // Raised if the serialization failed
        }
        // Deserialize into an object
        const pairs = payload.split('&');
        payload = {};
        for (let i = 0; i < pairs.length; i++) {
            const element = pairs[i];
            const kv = element.split('=');
            payload[kv[0]] = kv[1];
        }
    }

    let errorElement = document.getElementById('error-span');


    switch (payload.message) {
        case 'form.invalid':
            const iframeElement = document.getElementById('fz-payment-iframe');
            if (!errorElement) {
                errorElement = document.createElement('ul');
                errorElement.setAttribute('id', 'error-span');
            }

            const words = stringToList(payload.errors);
            errorElement.innerHTML = '';
            words.forEach(word => {
                const listItem = document.createElement('li');
                listItem.textContent = word;
                errorElement.appendChild(listItem);
            });

            errorElement.classList.add('EditingFormErrorLabel');
            errorElement.classList.add('fz-error');
            iframeElement.parentNode.insertBefore(errorElement, iframeElement.nextSibling);
            break;
        case 'form.valid':
            if (errorElement) {
                errorElement.innerHTML = '';
            }
            break;
        case 'transaction.complete':
            // Handle the transaction complete message.
            // Payload will be in e.data.data (eg. payload.data.r == 1)
            updateHiddenFields(payload.data);
            verifyFzResponse(payload.data)
                .then(response => handlePaymentSubmission(response))
                .catch(e => console.log(e));
            break;
        default:
            return false;
    }
};

if (window.addEventListener) { window.addEventListener('message', messageListener); } else { window.attachEvent('onmessage', messageListener); }




// WEBPACK FOOTER //
// ./src/sections/donation-header/fz.js